import React from 'react';
import PostBid from './postBid';

const NegotiateBid = () => {
  return (
    <PostBid showUpdateBid={true}/>
  )
}
export default NegotiateBid;